import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderSlot as _renderSlot, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, Teleport as _Teleport, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "fixed inset-0 z-50 overflow-y-auto"
}
const _hoisted_2 = { class: "flex min-h-screen items-center justify-center" }
const _hoisted_3 = { class: "border-b border-gray-700/50 px-6 py-4" }
const _hoisted_4 = { class: "text-lg font-medium leading-6 text-gray-100" }
const _hoisted_5 = { class: "px-6 py-4" }
const _hoisted_6 = { class: "space-y-4" }
const _hoisted_7 = { class: "border-t border-gray-700/50 bg-dark/30 px-6 py-4 sm:flex sm:flex-row-reverse sm:gap-2" }


export default /*@__PURE__*/_defineComponent({
  __name: 'BaseModal',
  props: {
    modelValue: { type: Boolean },
    maxWidth: {}
  },
  emits: ['update:modelValue'],
  setup(__props: any) {





return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    _createVNode(_Transition, {
      "enter-active-class": "transition ease-out duration-300",
      "enter-from-class": "opacity-0",
      "enter-to-class": "opacity-100",
      "leave-active-class": "transition ease-in duration-200",
      "leave-from-class": "opacity-100",
      "leave-to-class": "opacity-0"
    }, {
      default: _withCtx(() => [
        (_ctx.modelValue)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              _createElementVNode("div", _hoisted_2, [
                _createElementVNode("div", {
                  class: "fixed inset-0 bg-gray-900/90 backdrop-blur-sm",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('update:modelValue', false)))
                }),
                _createVNode(_Transition, {
                  "enter-active-class": "transition ease-out duration-300 transform",
                  "enter-from-class": "opacity-0 translate-y-8",
                  "enter-to-class": "opacity-100 translate-y-0",
                  "leave-active-class": "transition ease-in duration-200 transform",
                  "leave-from-class": "opacity-100 translate-y-0",
                  "leave-to-class": "opacity-0 translate-y-8"
                }, {
                  default: _withCtx(() => [
                    (_ctx.modelValue)
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 0,
                          style: _normalizeStyle(`max-width: ${_ctx.maxWidth}`),
                          class: "relative w-full max-w-lg transform rounded-xl bg-gradient-to-b from-dark-secondary/95 to-dark/95 text-left shadow-2xl ring-1 ring-gray-700/50"
                        }, [
                          _createElementVNode("div", _hoisted_3, [
                            _createElementVNode("h3", _hoisted_4, [
                              _renderSlot(_ctx.$slots, "title")
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_5, [
                            _createElementVNode("div", _hoisted_6, [
                              _renderSlot(_ctx.$slots, "default")
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_7, [
                            _renderSlot(_ctx.$slots, "footer")
                          ])
                        ], 4))
                      : _createCommentVNode("", true)
                  ]),
                  _: 3
                })
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 3
    })
  ]))
}
}

})